import {useMutation, useQueryClient} from '@tanstack/react-query'
import {Channel, ChannelsTypesE} from '../chat.model'
import {QUERY_KEYS} from './keys'
import {UserV3} from '@/features/authentication/types'
import {ChannelStatusToUpdateE, updateChannelStatus} from '../services/chat.http'
import {generateChatChannelName} from '@/utilities/helpers'
import {USER_ROLE_HOST} from '@/utilities/constants/user'

type UseUpdateChannelStatusOptions = {
    onSuccessCallback?: () => void
    onErrorCallback?: (error: Error) => void
}

type UpdateChannelStatusArgs = {
    chatId: string
    status: ChannelStatusToUpdateE
    representedCreatorId?: number
    currentUser: UserV3
}

export const useUpdateChannelStatusV3 = ({onSuccessCallback, onErrorCallback}: UseUpdateChannelStatusOptions) => {
    const queryClient = useQueryClient()

    return useMutation<Channel, Error, UpdateChannelStatusArgs>({
        mutationFn: ({chatId, status, representedCreatorId}) =>
            updateChannelStatus(chatId, status, representedCreatorId),

        onSuccess: (data, variables) => {
            queryClient.setQueryData(
                [
                    QUERY_KEYS.fetchChannelDetailsV3,
                    generateChatChannelName(data.rookieId, USER_ROLE_HOST, data.leaderId),
                    variables.representedCreatorId
                ],
                data
            )
            if (variables.currentUser) {
                queryClient.invalidateQueries({
                    queryKey: [QUERY_KEYS.fetchChannels, String(variables.currentUser.id), ChannelsTypesE.ACTIVE, '']
                })
                queryClient.invalidateQueries({
                    queryKey: [QUERY_KEYS.fetchChannels, String(variables.currentUser.id), ChannelsTypesE.INACTIVE, '']
                })
                queryClient.invalidateQueries({
                    queryKey: [QUERY_KEYS.fetchChannels, String(variables.currentUser.id), ChannelsTypesE.PAID, '']
                })
            }

            onSuccessCallback?.()
        },

        onError: error => {
            onErrorCallback?.(error)
        }
    })
}
